import React from 'react';
import { useTranslation } from 'react-i18next';
import PokerCard from './PokerCard';
import ResultCollapsibleSection from './ResultCollapsibleSection';

export const orderMatchPlayers = (players, playerId) => [...players].sort((a, b) =>
    Number(b.playerId === playerId) - Number(a.playerId === playerId));

export default function ShowedCardsResultRow({ upper, lower }) {
    const { t } = useTranslation();
    return <ResultCollapsibleSection
        className="declared-cards-wrapper showed-card-results"
        title={t('gameRoom.shownCards')}
    >
        <div className="showed-card-results-content">
            <div className="showed-card-result-item">
                <span className="showed-card-result-label">{t('gameSettings.upperShowCard')}</span>
                <PokerCard card={upper} isShowType />
            </div>
            <div className="showed-card-result-item">
                <span className="showed-card-result-label">{t('gameSettings.lowerShowCard')}</span>
                <PokerCard card={lower} isShowType />
            </div>
        </div>
    </ResultCollapsibleSection>;
}
